/**
 * This Store Module created to handle communication
 */

const state = {
  selectedThread: null,
  showNewThreadForm: false,
  threads: []
}

const actions = {
  setThreads({ commit, state }, threads) {
    commit('SET_THREADS', threads)
    if (state.selectedThread) {
      const updatedSelectedThread = threads.find(th => th.thread.id === state.selectedThread.thread.id)
      commit('SET_THREAD', updatedSelectedThread)
    }
  }
}

const mutations = {
  SET_THREADS: (state, threads) => {
    state.threads = threads
  },
  SET_THREAD: (state, thread) => {
    state.selectedThread = thread
  },
  SET_SHOW_NEW_THREAD_FORM: (state, thread) => {
    state.showNewThreadForm = thread
  }
}

export default {
  namespaced: true,
  state,
  actions,
  mutations
}
